<header #mainHeader class="main-header">

    <nav class=" navbar navbar-expand-lg fixed-top">
        <div class="container-fluid">
            <button class="navbar-toggler me-2" id="navbar-toggler" (click)="toggleMobileMenu($event)" type="button"
                data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <div class="toggle-line"></div>
            </button>

            <a class="navbar-brand " (click)="handleNavigateToDashboard()">
                <img src="../../../assets/images/logo-bird.svg" alt="">
            </a>


            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <!-- mobile-logo  -->
                <div class='mobile-logo'>
                    <a  class="logo" rel="home" aria-current="page" (click)="handleNavigateToDashboard()">
                        <img src="../../../assets/images/logo-bird.svg" alt="">
                    </a>

                    <!-- Close Button -->
                    <button class="navbar-toggler-mobile" id="navbar-toggler-close" (click)="closeMobileMenu()">
                        <div class='toggle-line'></div>
                    </button>
                </div>

                <ul class="navbar-nav me-auto">
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, serviceAcessUserRole)">
                        <a class="nav-link" aria-current="page" (click)="onNavLinkClick()"
                            [routerLink]="['/admin/work_area/dashboard']" routerLinkActive="active">
                            <i class="icon-home"></i> Dashboard
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole,salesBothAccessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()"
                            [routerLink]="['/admin/work_area/sales-order/dashboard']" routerLinkActive="active">
                            <i class="icon-home"></i> Sales Dashboard
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole,salesBothAccessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()"
                            [routerLink]="['/admin/work_area/sales-order/list']" routerLinkActive="active">
                            <i class="th th-outline-bag-2"></i> Sales Order
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole,salesBothAccessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()"
                            [routerLink]="['/admin/work_area/sales-order/reminders']" routerLinkActive="active">
                            <i class="th th-outline-notification-bing"></i> Reminders
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole,salesAccessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()"
                            [routerLink]="['/admin/work_area/sales-order/cancel-machines']" routerLinkActive="active">
                            <i class="th th-outline-bag-cross"></i> Our Stock
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, serviceAcessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()"
                            [routerLink]="['/admin/work_area/service-request/list']" routerLinkActive="active">
                            <i class="icon-setting"></i> Service Request
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, serviceAcessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()" [routerLink]="['/admin/work_area/trips']"
                            routerLinkActive="active">
                            <i class="bi bi-car-front"></i> Trips
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, serviceAcessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()" [routerLink]="['/admin/work_area/staff']"
                            routerLinkActive="active">
                            <i class="icon-profile-2user"></i> Staff
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, serviceAcessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()" [routerLink]="['/admin/work_area/customer/list']"
                            routerLinkActive="active">
                            <i class="icon-profile-2user"></i> Customers
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, serviceAcessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()" [routerLink]="['/admin/work_area/attendance']"
                            routerLinkActive="active">
                            <i class="icon-user-tick"></i> Attendance
                        </a>
                    </li>
                    <!-- <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, salesAccessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()" [routerLink]="['/admin/work_area/change-password']"
                            routerLinkActive="active">
                            <i class="th th-outline-lock"></i> Change Password
                        </a>
                    </li> -->
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, salesAccessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()" [routerLink]="['/admin/work_area/sales-order/machine-report']"
                            routerLinkActive="active">
                            <i class="th th-outline-document-text-1"></i> Machine Report
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, salesAccessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()" [routerLink]="['/admin/work_area/sales-order/china-ordered']"
                            routerLinkActive="active">
                            <i class="bi bi-file-earmark-spreadsheet"></i> China Ordered
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="handleShowTab(userDetail.userRole, salesAccessUserRole)">
                        <a class="nav-link" (click)="onNavLinkClick()" [routerLink]="['/admin/work_area/sales-order/sales-person-report']"
                            routerLinkActive="active">
                            <i class="th th-outline-document-text-1"></i> Sale Person Report
                        </a>
                    </li>

                </ul>
                <!-- <form class="header-search "><i class="icon-search-normal"></i><input type="text"
                    placeholder="Search by Customer Name" class="form-control me-2"></form>
            <div class="add-service">
                <button class="btn btn-secondary">
                    <i class="icon-add"></i> New Service
                </button>
            </div> -->
            </div>
            <div class="d-flex  align-items-center">

                <div class="header-notification header-item">
                    <a data-bs-toggle="offcanvas" (click)="openOffCanvas()" href="#notificationOffcanvas" role="button"
                        aria-controls="notificationOffcanvas">
                        <span class="">
                            <i class="icon-notification-bing"></i>
                        </span>
                        <div class="counter">{{this.utilsService.countOfNotification}}</div>
                    </a>
                </div>
                <div class="dropdown user-information">
                    <div class="user-block" data-bs-toggle="dropdown" aria-expanded="false">
                        <img src="../../../../assets/images/defaultuser.jpg" alt="">
                        <i class="icon-arrow-down"></i>
                    </div>

                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a class="dropdown-item drop-profile">
                                <div class="drop-user-menu">
                                    <div class="user-avtar">
                                        <img src="../../../../assets/images/defaultuser.jpg" alt="">
                                    </div>
                                    <div class="avtar-info">
                                        <h6>{{name?name:''}}</h6>
                                        <!-- <small>Administrator </small> -->
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li *ngIf="handleShowTab(userDetail.userRole, salesBothAccessUserRole)">
                            <a class="dropdown-item drop-seting"
                                [routerLink]="['/admin/work_area/change-password']"
                                routerLinkActive="router-link-active">
                                <i class="th th-outline-lock"></i>
                                <span>Change Password</span>
                            </a>
                        </li>
                        <li *ngIf="handleShowTab(userDetail.userRole, serviceAcessUserRole)">
                            <a class="dropdown-item drop-seting"
                                [routerLink]="['/admin/work_area/master/list/mcode-right']"
                                routerLinkActive="router-link-active">
                                <i class="icon-profile-2user"></i>
                                <span>Master</span>
                            </a>
                        </li>
                        <!-- <li>
                    <a class="dropdown-item drop-seting"  >
                        <i class="icon-setting-2"></i>
                        <span>Settings</span>
                    </a>
                </li> -->
                        <li>
                            <a class="dropdown-item drop-logout" (click)="logout()">
                                <i class="icon-logout"></i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
        </div>

        <div #menuOverlay class="menu-overlay" (click)="closeMobileMenu()"></div>
    </nav>

</header>


<div class="offcanvas offcanvas-end notification-offcanvas" tabindex="-1" id="notificationOffcanvas"
    aria-labelledby="notificationOffcanvasLabel">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="notificationOffcanvasLabel">Notification</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body p-0" *ngIf="showNotificationCanvas">
        <div class="notification-box" *ngIf="notification?.length > 0">
            <ul class="list-unstyled">
                <li *ngFor="let item of notification">
                    <div class="noti-icon">
                        <div class="noti-icon-box">
                            <img src="assets/images/megaphone.svg" alt="Liberty">
                        </div>
                    </div>
                    <div class="noti-details">
                        <p> {{item.notification}}</p>
                        <span>{{item.created_at | date:'dd/MM/yyyy hh:mm:ss a'}}</span>
                    </div>
                </li>
            </ul>
        </div>

        <div class="no-notification" *ngIf="notification?.length == 0">
            <img src="assets/images/no-notification.svg" alt="Liberty" />
            <p>You have no new notifications.</p>
        </div>
    </div>
</div>